import React, { useState, useEffect } from 'react';
import { getRuote, getRitardi, getFrequenze, getCoppieFrequenti, downloadPdfStatistiche } from '../services/api';

const Statistiche = () => {
  const [ruote, setRuote] = useState([]);
  const [selectedRuota, setSelectedRuota] = useState('');
  const [activeTab, setActiveTab] = useState('ritardi');
  const [ritardi, setRitardi] = useState([]);
  const [frequenze, setFrequenze] = useState([]);
  const [coppie, setCoppie] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRuote();
  }, []);

  useEffect(() => {
    loadData();
  }, [selectedRuota, activeTab]);

  const loadRuote = async () => {
    try {
      const res = await getRuote();
      setRuote(res.data);
    } catch (err) {
      console.error('Errore caricamento ruote:', err);
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const ruotaId = selectedRuota || null;
      
      if (activeTab === 'ritardi') {
        const res = await getRitardi(ruotaId, 30);
        setRitardi(res.data);
      } else if (activeTab === 'frequenze') {
        const res = await getFrequenze(ruotaId, 30);
        setFrequenze(res.data);
      } else if (activeTab === 'coppie') {
        const res = await getCoppieFrequenti(ruotaId, 20);
        setCoppie(res.data);
      }
    } catch (err) {
      console.error('Errore caricamento dati:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    try {
      const res = await downloadPdfStatistiche();
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'statistiche_lotto.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Errore download PDF');
    }
  };

  const getScoreClass = (ritardo, ritardoMax) => {
    const perc = ritardoMax > 0 ? (ritardo / ritardoMax) * 100 : 0;
    if (perc >= 70) return 'high';
    if (perc >= 40) return 'medium';
    return 'low';
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Statistiche</h2>
        <button className="btn btn-secondary" onClick={handleDownloadPdf}>
          📄 Esporta PDF
        </button>
      </div>

      {/* Filtro Ruota */}
      <div className="card" style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <label className="form-label" style={{ margin: 0 }}>Filtra per ruota:</label>
          <select
            className="form-select"
            style={{ width: 'auto', minWidth: '200px' }}
            value={selectedRuota}
            onChange={(e) => setSelectedRuota(e.target.value)}
          >
            <option value="">Tutte le ruote</option>
            {ruote.map((r) => (
              <option key={r.id} value={r.id}>{r.nome}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs">
        <div 
          className={`tab ${activeTab === 'ritardi' ? 'active' : ''}`}
          onClick={() => setActiveTab('ritardi')}
        >
          Ritardatari
        </div>
        <div 
          className={`tab ${activeTab === 'frequenze' ? 'active' : ''}`}
          onClick={() => setActiveTab('frequenze')}
        >
          Frequenti
        </div>
        <div 
          className={`tab ${activeTab === 'coppie' ? 'active' : ''}`}
          onClick={() => setActiveTab('coppie')}
        >
          Coppie Frequenti
        </div>
      </div>

      {loading ? (
        <div className="loading"><div className="spinner"></div></div>
      ) : (
        <div className="card">
          {/* Ritardatari */}
          {activeTab === 'ritardi' && (
            <table className="table">
              <thead>
                <tr>
                  <th>Numero</th>
                  <th>Ruota</th>
                  <th>Ritardo Attuale</th>
                  <th>Ritardo Max</th>
                  <th>Indice</th>
                </tr>
              </thead>
              <tbody>
                {ritardi.map((r, idx) => (
                  <tr key={idx}>
                    <td><span className="numero-ball">{r.numero}</span></td>
                    <td><span className="ruota-badge">{r.ruota_nome}</span></td>
                    <td><strong>{r.ritardo_attuale}</strong></td>
                    <td>{r.ritardo_max}</td>
                    <td style={{ width: '150px' }}>
                      <div className="score-bar">
                        <div 
                          className={`score-fill ${getScoreClass(r.ritardo_attuale, r.ritardo_max)}`}
                          style={{ width: `${Math.min((r.ritardo_attuale / r.ritardo_max) * 100, 100)}%` }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Frequenti */}
          {activeTab === 'frequenze' && (
            <table className="table">
              <thead>
                <tr>
                  <th>Numero</th>
                  <th>Ruota</th>
                  <th>Frequenza</th>
                  <th>Ultima Estrazione</th>
                </tr>
              </thead>
              <tbody>
                {frequenze.map((f, idx) => (
                  <tr key={idx}>
                    <td><span className="numero-ball">{f.numero}</span></td>
                    <td><span className="ruota-badge">{f.ruota_nome}</span></td>
                    <td><strong>{f.frequenza}</strong></td>
                    <td>{f.ultima_estrazione || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Coppie */}
          {activeTab === 'coppie' && (
            <table className="table">
              <thead>
                <tr>
                  <th>Coppia</th>
                  <th>Frequenza</th>
                </tr>
              </thead>
              <tbody>
                {coppie.map((c, idx) => (
                  <tr key={idx}>
                    <td>
                      <span className="numero-ball">{c.coppia[0]}</span>
                      <span className="numero-ball">{c.coppia[1]}</span>
                    </td>
                    <td><strong>{c.frequenza}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {((activeTab === 'ritardi' && ritardi.length === 0) ||
            (activeTab === 'frequenze' && frequenze.length === 0) ||
            (activeTab === 'coppie' && coppie.length === 0)) && (
            <p style={{ textAlign: 'center', color: '#718096', padding: '20px' }}>
              Nessun dato disponibile
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Statistiche;
